import { NumberParam, useQueryParam, withDefault } from 'use-query-params';

interface IUseDistance {
  distance: number;
  setDistance: (distance: number) => void;
  clearDistance: () => void;
}

export const DEFAULT_DISTANCE = 100;

export const useDistance = (): IUseDistance => {
  const [distance, setQuery] = useQueryParam(
    'distance',
    withDefault(NumberParam, DEFAULT_DISTANCE),
  );

  const clearDistance = () => setQuery(undefined, 'replaceIn');
  const setDistance = (distance: number) =>
    distance === DEFAULT_DISTANCE ? clearDistance() : setQuery(distance, 'replaceIn');

  return { distance, setDistance, clearDistance };
};

export default useDistance;
